import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import LocationsReport from 'components/Reports/LocationsReport';
// eslint-disable-next-line
export default function LocationsReportScreen(): JSX.Element {
  return (
    <ContentLayout>
      <SiteContent>
        <LocationsReport />
      </SiteContent>
    </ContentLayout>
  );
}
